// Third party
import { createSlice } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// Components
import { IRootState } from './type';
import { reducers } from './reducers';
import { PERSIST_KEYS, STORE_SLICES } from '../../utils';

const initialState: IRootState = {
  vcat_kits: [],
};

export const slice = createSlice({
  name: STORE_SLICES.VCAT_KITS_DATA,
  initialState,
  reducers,
});

const vcatKitsDataActions = slice.actions;

const vcatKitsDataPersistConfig = {
  key: PERSIST_KEYS.VCAT_KITS_DATA,
  storage,
};

export { vcatKitsDataActions, initialState };
export default persistReducer(vcatKitsDataPersistConfig, slice.reducer);
